import { RootState } from 'src/store/store';

export const selectUpdatedPermitData = (state: RootState) =>
  state.update?.applicationData;
export const selectDocumentUploadStarted = (state: RootState) =>
  state.update?.documentUploadStarted;
export const selectDocumentUploadWorking = (state: RootState) =>
  state.update?.documentUploadWorking;
export const selectDocumentUploadCompleted = (state: RootState) =>
  state.update?.documentUploadCompleted;
export const selectDocumentUploadErrors = (state: RootState) =>
  state.update?.documentUploadErrors ?? '';
export const selectApplicationNumber = (state: RootState) =>
  state.update?.applicationNumber;
export const selectInitiatingUpdateFlow = (state: RootState) =>
  state.update.initiatingUpdateFlow;
export const selectInitiatingUpdateFlowError = (state: RootState) =>
  state.update.initiatingUpdateFlowError;
export const selectUpdateLicenseInProgress = (state: RootState) =>
  state.update.updateLicenseInProgress;
export const selectUpdateLicenseError = (state: RootState) =>
  state.update.updateLicenseError ?? '';
